export default import.meta.ROLLUP_FILE_URL_nNROrST5crYsBG15fl_hmQ